import localDb from '@util/localDb';
import {queryAdminAccountList} from '@api/core/user';

// 按模块的action, reducer整合体
const ALL_USER = 'ALL_USER';

export function getAllUser() {
  return dispatch => {
    return queryAdminAccountList().then(res => {
      if (res.statusCode === 200) {
        localDb.set(ALL_USER, res.data.result);
        return dispatch({
          type: ALL_USER,
          data: res.data.result,
        });
      }
    });
  };
}

// Reducer
export function allUser(state = {}, action) {
  switch (action.type) {
    case ALL_USER:
      return action.data;
    default:
      return localDb.get(ALL_USER);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/all_user.js